module.exports = __webpack_public_path__ + "static/media/img-9147129a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/telewell-logo.png
// module id = 5303
// module chunks = 39